/* jshint -W024 */
// base script extends default script
import "./default";

Vue.component("shipping-country-select", () => import("./app/eros/components/pageDesign/ShippingCountrySelect.vue"));
Vue.component("basket-preview", () => import("./app/eros/components/basket/BasketPreview.vue"));
Vue.component("basket-totals", () => import("./app/eros/components/basket/BasketTotals.vue"));
Vue.component("coupon", () => import("./app/eros/components/basket/Coupon.vue"));
Vue.component("basket-list", () => import("./app/eros/components/basket/list/BasketList.vue"));
Vue.component("return-country-select", () => import("./app/eros/components/common/ReturnCountrySelect.vue"));
import ItemFilterList from "./app/eros/components/itemList/filter/ItemFilterList.vue";
Vue.component("item-filter-list", ItemFilterList);
Vue.component("item-filter", () => import("./app/eros/components/itemList/filter/ItemFilter.vue"));


import CategoryImageCarousel from "./app/eros/components/itemList/CategoryImageCarousel.vue";
import CategoryItemSiblingUSP from "./app/eros/components/itemList/CategoryItemSiblingUSP.vue";
import CategoryItemSiblings from "./app/eros/components/itemList/CategoryItemSiblings.vue";
Vue.component("category-image-carousel", CategoryImageCarousel);
Vue.component("category-item-sibling-usp", CategoryItemSiblingUSP);
Vue.component("category-item-siblings", CategoryItemSiblings);

// =========================
// External Plugins
// =========================
import "./app/eros/plugins/external/svbadge";
